// ContactUsPage.js
import React, { useState } from 'react';
import styles from './ContactUsPage.module.css';
//import CallInterface from './CallInterface';
const ContactUsPage = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  //const [isCallOpen, setIsCallOpen] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const SERVICE_LABELS = {
  "ai-services": "AI Services",
  "cyber-services": "Cybersecurity Services",
  "web-services": "Web Services",
  "digital-services": "Digital Services",
};

const getMessagePlaceholder = (subject) => {
  const label = SERVICE_LABELS[subject];
  return label
    ? `Tell us about your ${label.toLowerCase()} needs...`
    : "Tell us about your project...";
};


  const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  setSubmitStatus(null);

  try {
    const response = await fetch("https://backend.virtualipus.com/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      throw new Error("Failed to send form");
    }

    const data = await response.json();
    console.log("Response from backend:", data);

    setSubmitStatus('success');
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      company: '',
      subject: '',
      message: ''
    });
  } catch (error) {
    console.error("Submission error:", error);
    setSubmitStatus('error');
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <div className={styles.contactPage}>

        {/*}
        <CallInterface isOpen={isCallOpen} onClose={() => setIsCallOpen(false)} />*/}
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroBackground}></div>
        <div className={styles.heroContainer}>
          <h1 className={styles.heroTitle}>Contact Us</h1>
          <p className={styles.heroSubtitle}>
            Get in touch with our cybersecurity experts to discuss your security needs
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className={styles.mainContent}>
        <div className={styles.container}>
          <div className={styles.contentGrid}>
            
            {/* Left Side - Contact Information */}
            <div className={styles.contactInfo}>
              <div className={styles.infoSection}>
                <h2 className={styles.sectionTitle}>Get In Touch</h2>
                <p className={styles.sectionDescription}>
                  Ready to enhance your cybersecurity posture? Our team of experts is here to help you protect what matters most.
                </p>
              </div>

              {/* Contact Details */}
              <div className={styles.contactDetails}>
                <div className={styles.contactItem}>
                  <div className={styles.contactIcon}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                  </div>
                  <div className={styles.contactText}>
                    <h3>Address</h3>
                    <p>7801 Alma Dr Suite 105 Plano, TX 75025</p>
                  </div>
                </div>

                <div className={styles.contactItem}>
                  <div className={styles.contactIcon}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                  </div>
                  <div className={styles.contactText}>
                    <h3>Email</h3>
                    <p>info@virtualplus.com</p>
                  </div>
                </div>

                

                <div className={styles.contactItem}>
                  <div className={styles.contactIcon}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12,6 12,12 16,14"></polyline>
                    </svg>
                  </div>
                  <div className={styles.contactText}>
                    <h3>Business Hours</h3>
                    <p>Monday - Friday: 9:00 AM - 6:00 PM<br />Saturday: 10:00 AM - 4:00 PM<br />Sunday: Closed</p>
                  </div>
                </div>
                <div className={styles.contactItem}>
  <div className={styles.contactIcon}>
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M22 16.92V21a2 2 0 0 1-2.18 2
               19.86 19.86 0 0 1-8.63-3.07
               A19.5 19.5 0 0 1 3.07 10.8
               19.86 19.86 0 0 1 0 2.18
               A2 2 0 0 1 2 0h4.09a2 2 0 0 1 2 1.72
               c.2 1.38.62 2.71 1.23 3.96
               a2 2 0 0 1-.45 2.18L7.91 9.09
               a16 16 0 0 0 7 7l1.23-1.23
               a2 2 0 0 1 2.18-.45
               c1.25.61 2.58 1.03 3.96 1.23
               a2 2 0 0 1 1.72 2z" />
    </svg>
  </div>
  <div className={styles.contactText}>
    <h3>Phone</h3>
    <p>+1 (972) 476 5199</p>
  </div>
</div>
                
              </div>

              {/* Map Section */}
              <div className={styles.mapSection}>
                <h3 className={styles.mapTitle}>Our Location</h3>
                <div className={styles.mapContainer}>
                  <div className={styles.interactiveMap}>
                    <div className={styles.mapBackground}></div>
                    <div className={styles.mapPin}>
                      <div className={styles.pinIcon}>
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                          <circle cx="12" cy="10" r="3"/>
                        </svg>
                      </div>
                      <div className={styles.pinPulse}></div>
                    </div>
                    <div className={styles.mapInfo}>
                      <div className={styles.infoCard}>
                        <h4>Virtual IP</h4>
                        <p>7801 Alma Dr Suite 105 Plano, TX 75025</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Contact Form */}
            <div className={styles.contactForm}>
              <div className={styles.formContainer}>
                <h2 className={styles.formTitle}>Send Us a Message</h2>
                <p className={styles.formDescription}>
                  Fill out the form below and we'll get back to you within 24 hours.
                </p>

                <form onSubmit={handleSubmit} className={styles.form}>
                  <div className={styles.formRow}>
                    <div className={styles.formGroup}>
                      <label htmlFor="firstName" className={styles.label}>
                        First Name *
                      </label>
                      <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        className={styles.input}
                        required
                      />
                    </div>
                    <div className={styles.formGroup}>
                      <label htmlFor="lastName" className={styles.label}>
                        Last Name *
                      </label>
                      <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        className={styles.input}
                        required
                      />
                    </div>
                  </div>

                  <div className={styles.formRow}>
                    <div className={styles.formGroup}>
                      <label htmlFor="email" className={styles.label}>
                        Email Address *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className={styles.input}
                        required
                      />
                    </div>
                    <div className={styles.formGroup}>
                      <label htmlFor="phone" className={styles.label}>
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        className={styles.input}
                      />
                    </div>
                  </div>

                  <div className={styles.formGroup}>
                    <label htmlFor="company" className={styles.label}>
                      Company
                    </label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleInputChange}
                      className={styles.input}
                    />
                  </div>

                  <div className={styles.formGroup}>
                    <label htmlFor="subject" className={styles.label}>
                      Service 
                    </label>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      className={styles.select}
                      required
                    >
                      <option value="">Select a service</option>
                      <option value="ai-services">AI Services</option>
                      <option value="cyber-services">Cybersecurity Services</option>
                      <option value="web-services">Web Services</option>
                      <option value="digital-services">Digital Services</option>
                    </select>
                  </div>

                  <div className={styles.formGroup}>
                    <label htmlFor="message" className={styles.label}>
                      Message *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      className={styles.textarea}
                      rows="6"
                      placeholder={getMessagePlaceholder(formData.subject)} 
                      required
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className={`${styles.submitButton} ${isSubmitting ? styles.submitting : ''}`}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <div className={styles.spinner}></div>
                        Sending...
                      </>
                    ) : (
                      'Send Message'
                    )}
                  </button>

                  {/* Make a Call Button */}
                  {/*
                  <button
                    type="button"
                    onClick={() => setIsCallOpen(true)}
                    className={styles.submitButton}
                    style={{ marginTop: '1rem', backgroundColor: '#059669' }}
                  >
                    Make a Call
                  </button>
                  */}
                  {submitStatus === 'success' && (
                    <div className={styles.successMessage}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="9,11 12,14 22,4"></polyline>
                        <path d="M21,12v7a2,2 0 0,1 -2,2H5a2,2 0 0,1 -2,-2V5a2,2 0 0,1 2,-2h11"></path>
                      </svg>
                      Thank you! Your message has been sent successfully. We'll get back to you within 24 hours.
                    </div>
                  )}

                  {submitStatus === 'error' && (
                    <div className={styles.errorMessage}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                      </svg>
                      Sorry, there was an error sending your message. Please try again or contact us directly.
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUsPage;